const translations = {
    'jobs.assistantMinus': 'Pomocnik -',
    'jobs.assistantPlus': 'Pomocnik +',
    'jobs.assistants': 'Pomocnicy: %d/%d',
    'jobs.builderMinus': 'Budowniczy -',
    'jobs.builderPlus': 'Budowniczy +',
    'jobs.builders': 'Budowniczowie: %d/%d',
    'jobs.burnerMinus': 'Wypalacz -',
    'jobs.burnerPlus': 'Wypalacz +',
    'jobs.burners': 'Wypalacze: %d/%d',
    'jobs.farmerMinus': 'Rolnik -',
    'jobs.farmerPlus': 'Rolnik +',
    'jobs.farmers': 'Rolnicy: %d/%d',
    'jobs.fisherMinus': 'Rybak -',
    'jobs.fisherPlus': 'Rybak +',
    'jobs.fishers': 'Rybacy: %d/%d',
    'jobs.foresterMinus': 'Leśnik -',
    'jobs.foresterPlus': 'Leśnik +',
    'jobs.foresters': 'Leśnicy: %d/%d',
    'jobs.free': 'Wolna populacja: %d',
    'jobs.goldMinerMinus': 'Górnik złota -',
    'jobs.goldMinerPlus': 'Górnik złota +',
    'jobs.goldMiners': 'Górnicy złota: %d/%d',
    'jobs.hunterMinus': 'Myśliwy -',
    'jobs.hunterPlus': 'Myśliwy +',
    'jobs.hunters': 'Myśliwi: %d/%d',
    'jobs.lumberjackMinus': 'Drwal -',
    'jobs.lumberjackPlus': 'Drwal +',
    'jobs.lumberjacks': 'Drwale: %d/%d',
    'jobs.masonMinus': 'Ceglarz -',
    'jobs.masonPlus': 'Ceglarz +',
    'jobs.masons': 'Ceglarze: %d/%d',
    'jobs.minerMinus': 'Górnik -',
    'jobs.minerPlus': 'Górnik +',
    'jobs.miners': 'Górnicy: %d/%d',
    'jobs.minterMinus': 'Mincerz -',
    'jobs.minterPlus': 'Mincerz +',
    'jobs.minters': 'Mincerze: %d/%d',
    'jobs.militiaMinus': 'Milicja -',
    'jobs.militiaPlus': 'Milicja +',
    'jobs.militia': 'Milicja: %d/%d',
    'jobs.quarrymanMinus': 'Kamieniarz -',
    'jobs.quarrymanPlus': 'Kamieniarz +',
    'jobs.quarrymen': 'Kamieniarze: %d/%d',
    'jobs.sawmillerMinus': 'Tartacznik -',
    'jobs.sawmillerPlus': 'Tartacznik +',
    'jobs.sawmillers': 'Tartacznicy: %d/%d',
    'jobs.section': 'Prace',
    'jobs.smelterMinus': 'Hutnik -',
    'jobs.smelterPlus': 'Hutnik +',
    'jobs.smelters': 'Hutnicy: %d/%d',
    'jobs.smithMinus': 'Kowal -',
    'jobs.smithPlus': 'Kowal +',
    'jobs.smiths': 'Kowale: %d/%d',
    'jobs.smokerMinus': 'Wędzarz -',
    'jobs.smokerPlus': 'Wędzarz +',
    'jobs.smokers': 'Wędzarze: %d/%d',
    'jobs.weaverMinus': 'Tkacz -',
    'jobs.weaverPlus': 'Tkacz +',
    'jobs.weavers': 'Tkacze: %d/%d',
    'jobs.name.unassigned': 'Brak przydziału',
    'jobs.name.assistants': 'Pomocnik',
    'jobs.name.builders': 'Budowniczy',
    'jobs.name.burners': 'Wypalacz',
    'jobs.name.farmers': 'Rolnik',
    'jobs.name.fishers': 'Rybak',
    'jobs.name.foresters': 'Leśnik',
    'jobs.name.goldMiners': 'Górnik złota',
    'jobs.name.hunters': 'Myśliwy',
    'jobs.name.lumberjacks': 'Drwal',
    'jobs.name.masons': 'Ceglarz',
    'jobs.name.miners': 'Górnik',
    'jobs.name.minters': 'Mincerz',
    'jobs.name.militia': 'Milicja',
    'jobs.name.quarrymen': 'Kamieniarz',
    'jobs.name.sawmillers': 'Tartacznik',
    'jobs.name.smelters': 'Hutnik',
    'jobs.name.smiths': 'Kowal',
    'jobs.name.smokers': 'Wędzarz',
    'jobs.name.weavers': 'Tkacz',
};

export default translations;
